"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
/**
 * Given a react keyboard event object identify if ctrl or cmd key is pressed
 * @param  {KeyboardEvent}  event A react Keyboard event object
 * @return {Boolean}       If Cmd key is pressed for Mac OS or if Ctrl is pressed for other OS
 */

var _default = function _default(event) {
  var isMacLike = /(Mac|iPhone|iPod|iPad)/i.test(navigator.platform);
  return isMacLike && event.metaKey || !isMacLike && event.ctrlKey;
};

exports.default = _default;